import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

import { TravelBoardOutcome, travelBoardOutcomeList } from '../../model/TravelApprovalTypes';

export type TravelBoardOutcomeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

const outcomeLabels: Record<TravelBoardOutcome, string> = {
  approve: 'travel.stepFamily.approval.positive',
  reject: 'travel.stepFamily.approval.negative',
};

export function TravelBoardOutcomeSelectControl<T extends FieldValues>(props: TravelBoardOutcomeSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(() => travelBoardOutcomeList.map(value => ({ value, label: t(outcomeLabels[value]) })), [t]);

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
